import Encoding from 'encoding-japanese'

export const convertCharCodeExportCSV = (
  charCode: 'sjis' | 'utf8' | 'utf8bom',
  csvData: string,
) => {
  let To: Encoding.Encoding

  switch (charCode) {
    case 'sjis':
      To = 'SJIS'
      break
    case 'utf8':
    case 'utf8bom':
      // BOM の有無は文字エンコード自体には影響しない（BOM付与は createDownloadFileUrl 側で行う）
      To = 'UTF8'
      break
  }

  const csvDataCode = Encoding.stringToCode(csvData)
  const csvDataSjisCode = Encoding.convert(csvDataCode, {
    to: To,
    from: 'AUTO',
  })

  const u8 = new Uint8Array(csvDataSjisCode)
  const blob = new Blob([u8], { type: 'text/csv' })

  return blob
}
